import { useQuery } from '@tanstack/react-query'
import { strapiGet } from '@/lib/strapi'
import { useAppStore } from '@/lib/store/useAppStore'

export interface ReceiverDevice {
  documentId: string
  platform: string | null
  deviceName: string | null
  deviceId: string | null
  appVersion: string | null
  nativeTokenType: string | null
  lastSeenAt: string | null
  registeredAt: string | null
  updatedAt: string | null
  restaurant: {
    documentId: string
    name: string | null
    slug: string | null
  } | null
  connection: {
    online: boolean
    connectedAt: string | null
    lastPongAt: string | null
    ipAddress: string | null
    userAgent: string | null
    appVersion: string | null
    platform: string | null
  }
}

export interface ReceiverDeviceReport {
  summary: {
    total: number
    online: number
    offline: number
  }
  devices: ReceiverDevice[]
}

export function useReceiverDevices() {
  const restaurantId = useAppStore((s) => s.restaurantId)
  return useQuery({
    queryKey: ['receiver-devices', restaurantId],
    queryFn: () => strapiGet<ReceiverDeviceReport>('/api/device-push-tokens'),
    enabled: !!restaurantId,
    refetchInterval: 15_000,
    staleTime: 10_000,
  })
}
